module.exports = __webpack_public_path__ + "img/emoji-25.4054c5ee.png";